import { REACT_APP_MIDDLEWARE_URL } from "shared/config/";
import { DefaultApi } from "shared/api/middleware-api-client";

export function api() {
  return new DefaultApi({
    basePath: REACT_APP_MIDDLEWARE_URL,
    isJsonMime: (mime: any) => true,
  });
}
